// Script for P2/P22/P38 START by JT on Feb 22 at 3:28 Japan Time
// This is a workaround for P2
// There are conflicting scripts resulting to click event being disrupted and prevents firing of the correct function.
// Slick slider is displaying errors on console.log() upon clicking.
$(window).on('load',function(){
  
    $("ul.tt-options-swatch.productitem-option1-js").on("click touchstart", "li a", function(){
      	
		var closest = $(this).closest(".respimgsize.tt-product.product-parent");
      
      	var workaroundParentImg = closest.find(".tt-image-box");
      	var workaroundParentImgHref = workaroundParentImg.find('.tt-img-parent').attr("href");
      	if ( workaroundParentImgHref === undefined ) { return; }
      
      	var workaroundParentDesc = closest.find(".tt-description");
      	var workaroundParentDescVarId = $(this).parent().attr('data-var_id');
      	var workaroundParentDescImg = $(this).parent().attr('data-img');
      	if ( workaroundParentDescVarId === undefined ) { return; }
        if ( workaroundParentDescImg === undefined ) { return; }
      	
      	workaroundParentImg.find('a[class^="productItemUrl"] img').attr("srcset",workaroundParentDescImg);
      	workaroundParentImg.find('a[class^="productItemUrl"] img').attr("data-mainimage",workaroundParentDescImg);
      	workaroundParentImg.find('a[class^="productItemUrl"] img').attr("data-srcset",workaroundParentDescImg);
      
      	if ( workaroundParentImgHref.indexOf("?") >= 0 ) {
            var workaroundParentImgHrefNew = workaroundParentImgHref.split("?")[0];
            workaroundParentImg.find('.tt-img-parent').attr("href",workaroundParentImgHrefNew+"?variant="+workaroundParentDescVarId);
        } else {
            workaroundParentImg.find('.tt-img-parent').attr("href",workaroundParentImgHref+"?variant="+workaroundParentDescVarId);
        }
      
    });
        
});